import { buildCdnUrl, http, INSTITUTION_REFERENCE } from "@/lib/api";

const mapEvent = item => ({
  id: item.eventId,
  image: buildCdnUrl(item.eventThumbnail),
  date: item.eventDate,
  title: item.head || item.name || "",
  location: item.location || "Sri Bhimanakatte Matha, Thirthahalli",
  description: item.englishText || item.kannadaText || item.name || "",
  englishText: item.englishText || "",
  kannadaText: item.kannadaText || "",
  raw: item,
});

const mapEventDetail = (item, eventId) => ({
  id: item?.eventId || eventId,
  title: item?.head || item?.name || "",
  date: item?.eventDate || item?.date || "",
  englishText: item?.englishText || "",
  kannadaText: item?.kannadaText || "",
  images: Object.keys(item?.images || {}).map(buildCdnUrl).filter(Boolean),
  raw: item,
});

export async function fetchEvents({ size, index = 0, status = 1, eventTypeId } = {}) {
  const response = await http.get("/shared/event", {
    params: {
      institutionReference: INSTITUTION_REFERENCE,
      status,
      index,
      ...(eventTypeId ? { eventTypeId } : {}),
      ...(size ? { size } : {}),
    },
  });

  return response?.data?.data?.results?.map(mapEvent) || [];
}

export async function fetchSancharaStops(options = {}) {
  const events = await fetchEvents({ ...options, eventTypeId: 4 });

  return events.map(event => ({
    ...event,
    location: event.raw?.location || event.raw?.head || event.raw?.name || "Sri Bhimanakatte Matha, Thirthahalli",
    description: event.raw?.englishText || event.raw?.kannadaText || event.raw?.name || "",
  }));
}

export async function fetchGalleryImages(options = {}) {
  const events = await fetchEvents({ ...options, eventTypeId: 1 });

  return events
    .filter(event => event.image)
    .map(event => ({
      id: event.id,
      image: event.image,
      title: event.title,
      category: "Matha",
      raw: event.raw,
    }));
}

export async function fetchEventDetail(eventId) {
  const response = await http.get(`/shared/event/${eventId}`);
  return mapEventDetail(response?.data?.data, eventId);
}
